import {MatTableModule} from '@angular/material/table';
import {MatButtonModule} from '@angular/material/button';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { ConvocatoriasComponent } from './convocatorias.component';
import {MatCardModule} from '@angular/material/card';

export const routes = [
  { path: '', component: ConvocatoriasComponent, pathMatch: 'full'  }
];

@NgModule({
  declarations: [ConvocatoriasComponent],
  imports: [
    MatCardModule,
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,    
    MatTableModule,
    MatButtonModule
  ]
})

export class ConvocatoriasModule { }
